import React from "react"
import Marquee from 'react-fast-marquee';
import { FaHome } from "react-icons/fa";
import { TbUserDollar } from "react-icons/tb";
import { FaHandHoldingDollar } from "react-icons/fa6";



import godrej from '../../assets/tycoons/goderj.png'
// import lnt from '../../assets/tycoons/lnt.png'
import lnt from '../../assets/tycoons/lt.jpeg'
import dlf from '../../assets/tycoons/dlf.png'
import max from '../../assets/tycoons/max.png'
import ace from '../../assets/tycoons/ace.png'
import ats from '../../assets/tycoons/ats.png'
import tata from '../../assets/tycoons/tata.png'
import sobha from '../../assets/tycoons/sobha.png'
import birla from '../../assets/tycoons/birla.png'
import heroHomes from '../../assets/tycoons/heroHomes.png'


export const Tycoons = () => {
    return (
        <div className="bg-gray-100 py-10 px-4 sm:px-6 lg:px-20">
            <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-sm px-6 py-16">

                <h2 className="text-xl sm:text-2xl md:text-3xl uppercase font-bold text-gray-800 text-center mb-12">
                    Who <span className="text-green-600">We Help</span>
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Real Estate Investors */}
                    <div className="bg-gray-50 rounded-xl p-6 shadow-md hover:shadow-lg transition border-2 border-transparent hover:border-green-600">
                        <div className="flex items-center justify-center mb-4">
                            <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full">
                                <FaHandHoldingDollar className="text-green-600" size={23} />
                            </div>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">Real Estate Investors</h3>
                        <p className="text-gray-600 text-justify">
                            Looking for pre-leased spaces or high-growth properties? We offer investment properties with assured rental returns and appreciation.
                        </p>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-6 shadow-md hover:shadow-lg transition border-2 border-transparent hover:border-green-600">
                        <div className="flex items-center justify-center mb-4">
                            <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full">
                                <FaHome className="text-green-600" size={23} />
                            </div>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">Homebuyers</h3>
                        <p className="text-gray-600 text-justify">
                            Get help buying your first or second home with personalized options in your desired city and budget.
                        </p>
                    </div>

                    {/* NRI Buyers */}
                    <div className="bg-gray-50 rounded-xl p-6 shadow-md hover:shadow-lg transition border-2 border-transparent hover:border-green-600">
                        <div className="flex items-center justify-center mb-4">
                            <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full">
                                <TbUserDollar className="text-green-600" size={23} />
                            </div>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">NRI Buyers</h3>
                        <p className="text-gray-600 text-justify">
                            We provide complete end-to-end solutions for NRIs, including virtual site visits, legal verification, and registration assistance.
                        </p>
                    </div>
                </div>
            </div>

            {/* Tycoons of Town */}
            <h2 className="text-xl sm:text-3xl md:text-3xl uppercase font-bold text-gray-800 text-center my-12">
                Tycoons of Town
            </h2>
            <div className="marquee-container py-5 px-4 sm:px-10 lg:px-20">
                <Marquee direction="left" gradient={false}>
                    {[lnt, tata, godrej, ace, sobha, max, birla, dlf, ats, heroHomes].map((logo, i) => (
                        <div key={i} className="mx-5 sm:mx-7 max-w-[150px] sm:max-w-[200px] flex justify-center items-center">
                            <img src={logo} alt={`logo-${i}`} className="w-4/5 sm:max-w-xs" />
                        </div>
                    ))}
                </Marquee>
            </div>
        </div>

    )
}